import React, { useState, useEffect, useCallback, useRef } from 'react';
import { trackPageView } from '../utils/analytics';
import { keyframes } from '@emotion/react';
import { Box, Container, Typography, Grid, Button, Card, useMediaQuery, useTheme, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert, FormHelperText, CircularProgress, Paper, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { styled } from '@mui/material/styles';
import { useNavigate, Link } from 'react-router-dom';
import Footer from './shared/Footer';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PsychologyIcon from '@mui/icons-material/Psychology';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LanguageIcon from '@mui/icons-material/Language';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import StorageIcon from '@mui/icons-material/Storage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DevicesIcon from '@mui/icons-material/Devices';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import StarIcon from '@mui/icons-material/Star';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SchoolIcon from '@mui/icons-material/School';


import NavBar from './shared/NavBar';
import ChristmasOfferBanner from './shared/ChristmasOfferBanner';
import Testimonials from './shared/Testimonials';
import MagazineCoverGrid from './shared/MagazineCoverGrid';
const DIGITAL_FRIENDLY_ICON = 'https://dp9h3awfnhccl.cloudfront.net/public_folder/digital-friendly.png';
const MAKE_IT_EASY_ICON = 'https://dp9h3awfnhccl.cloudfront.net/public_folder/make-it-easy.png';
const REWARDS_ICON = 'https://dp9h3awfnhccl.cloudfront.net/public_folder/rewards.jpg';
const WALL_OF_FAME_ICON = 'https://dp9h3awfnhccl.cloudfront.net/public_folder/wall-of-fame.jpg';
const LOGO_IMAGE = "https://dp9h3awfnhccl.cloudfront.net/public_folder/logo-abhi-1-Logo.png";
const HOME_BANNER_IMAGE = "https://dp9h3awfnhccl.cloudfront.net/public_folder/home_banneryp.jpg";
const CURENT_AFFAIRS_IMAGE = "https://dp9h3awfnhccl.cloudfront.net/public_folder/Breaking+News.png";
const LATEST_TECH_IMAGE= 'https://dp9h3awfnhccl.cloudfront.net/public_folder/Tech+Updates.png';
const KNOWLEDGE_IMAGE= 'https://dp9h3awfnhccl.cloudfront.net/public_folder/Did+You+Know.png';
const CREATIVE_IMAGE= 'https://dp9h3awfnhccl.cloudfront.net/public_folder/Wall+Of+Fame.png';

const HeroImage = styled('img')({
  width: '100%',
  maxWidth: '500px',
  height: 'auto',
  marginTop: '2rem',
  borderRadius: '20px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
  animation: 'float 3s ease-in-out infinite',
  '@keyframes float': {
    '0%': {
      transform: 'translateY(0px)'
    },
    '50%': {
      transform: 'translateY(-10px)'
    },
    '100%': {
      transform: 'translateY(0px)'
    }
  }
});

const FeatureImage = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  maxHeight: '100%',
  transition: 'transform 0.5s ease, filter 0.5s ease',
  animation: 'float 3s ease-in-out infinite',
  '@keyframes float': {
    '0%': {
      transform: 'translateY(0px)'
    },
    '50%': {
      transform: 'translateY(-10px)'
    },
    '100%': {
      transform: 'translateY(0px)'
    }
  },
  '&:hover': {
    transform: 'scale(1.1) rotate(3deg)',
    filter: 'brightness(1.1)'
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '120%',
    maxHeight: '120%',
    transform: 'translateX(-10%)'
  }
}));

const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  aspectRatio: '1/1', // Modern way to create square
  overflow: 'hidden',
  borderRadius: '24px',
  boxShadow: '0 8px 20px rgba(255, 107, 53, 0.25)',
  maxWidth: '100%',
  margin: '0 auto',
}));

const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'transform 0.5s ease-in-out, filter 0.5s ease',
  filter: 'brightness(1.05)',
  '&:hover': {
    filter: 'brightness(1.1)'
  }
});

const CarouselButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 2,
  backgroundColor: 'rgba(255, 107, 53, 0.7)',
  color: '#fff',
  width: '24px', // Half the size
  height: '24px', // Half the size
  transition: 'all 0.5s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 107, 53, 0.9)',
    transform: 'translateY(-50%) scale(1.1)',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '3px',
    width: '20px', // Half the size for mobile
    height: '20px' // Half the size for mobile
  }
}));

// Define keyframes animations
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
`;

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(5deg); }
  75% { transform: rotate(-5deg); }
  100% { transform: rotate(0deg); }
`;

const ProgramImage = styled('img')({
  width: '160px',
  height: '160px',
  marginBottom: '24px',
  borderRadius: '16px',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  animation: `${rotate} 3s ease-in-out infinite`,
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: '0 10px 25px rgba(255,107,53,0.3)',
  }
});

const ProgramCard = styled(Card)(({ color }) => ({
  height: '100%',
  padding: '32px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  borderRadius: '20px',
  background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
  }
}));

const StatIconWrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '16px',
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '160px',
    height: '160px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, rgba(255,107,53,0.1) 0%, rgba(255,107,53,0) 100%)',
    zIndex: -1
  }
});

const StatIcon = styled('img')({
  width: '140px',
  height: '140px',
  marginBottom: '24px',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  }
});

const StatNumber = styled(Typography)({
  fontSize: '3.5rem',
  fontWeight: 'bold',
  color: '#FF6B35',
  marginBottom: '16px',
  lineHeight: 1
});

const NavButton = styled(Button)(({ theme }) => ({
  color: '#1A1A1A',
  marginLeft: theme.spacing(2),
  '&:hover': {
    backgroundColor: 'rgba(0,0,0,0.04)',
  },
}));

const GetStartedButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#FF6B35',
  color: 'white',
  padding: theme.spacing(1, 3),
  borderRadius: '25px',
  marginLeft: theme.spacing(2),
  '&:hover': {
    backgroundColor: '#FF5722',
  },
}));

const HeroSection = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #2a2a2a 100%)',
  padding: theme.spacing(10, 0),
  textAlign: 'center',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    background: 'radial-gradient(circle at 50% 50%, rgba(255,107,53,0.1) 0%, transparent 70%)',
    opacity: 0.8,
    pointerEvents: 'none',
  }
}));

const FeatureCard = styled(Card)(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(3),
  textAlign: 'center',
  background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)',
  borderRadius: '20px',
  border: '1px solid rgba(255,107,53,0.2)',
  backdropFilter: 'blur(10px)',
  transition: 'all 0.4s ease',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '&:hover': {
    transform: 'translateY(-8px) scale(1.02)',
    boxShadow: '0 20px 40px rgba(255,107,53,0.3)',
    border: '1px solid rgba(255,107,53,0.4)',
  }
}));

const StatsBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 0),
  background: 'linear-gradient(135deg, rgba(255,107,53,0.1) 0%, rgba(6,174,213,0.1) 100%)',
  borderRadius: '24px',
  margin: theme.spacing(4, 0),
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255,255,255,0.1)'
}));

const ActionButton = styled(Button)(({ theme, color = '#FF6B35' }) => ({
  padding: '14px 40px',
  fontSize: '1.1rem',
  fontWeight: 600,
  borderRadius: '50px',
  textTransform: 'none',
  background: 'linear-gradient(45deg, #FF6B35 30%, #FF8A65 90%)',
  boxShadow: '0 6px 20px rgba(255,107,53,0.3)',
  transition: 'all 0.4s ease',
  '&:hover': {
    transform: 'translateY(-3px) scale(1.05)',
    boxShadow: '0 12px 30px rgba(255,107,53,0.4)',
    background: 'linear-gradient(45deg, #FF5722 30%, #FF6B35 90%)',
  }
}));

const BannerContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: { xs: '200px', sm: '300px', md: '400px', lg: '500px' },
  overflow: 'hidden',
  boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
  marginBottom: theme.spacing(4),
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(45deg, rgba(255,107,53,0.2) 0%, rgba(6,174,213,0.2) 100%)',
    zIndex: 1,
    pointerEvents: 'none'
  }
}));

const BannerImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.02)',
  }
}));

const BannerOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.4) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2,
  padding: theme.spacing(2)
}));

const BannerContent = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  color: 'white',
  maxWidth: '800px',
  padding: theme.spacing(2),
  background: 'rgba(255,255,255,0.1)',
  borderRadius: '20px',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255,255,255,0.2)',
  animation: 'fadeInUp 1s ease-out',
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)'
    }
  }
}));

const CAROUSEL_IMAGES = [
  "https://dp9h3awfnhccl.cloudfront.net/public_folder/carousel-1.jpg",
  "https://dp9h3awfnhccl.cloudfront.net/public_folder/carousel-2.jpg",
  "https://dp9h3awfnhccl.cloudfront.net/public_folder/carousel-3.jpg",
  "https://dp9h3awfnhccl.cloudfront.net/public_folder/carousel-4.jpg"
];

const Home = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const navigate = useNavigate();
  
  
  const [currentImage, setCurrentImage] = useState(0);
  
  const handleCarouselNav = useCallback((direction) => {
    if (direction === 'next') {
      setCurrentImage(prev => (prev + 1) % CAROUSEL_IMAGES.length);
    } else {
      setCurrentImage(prev => (prev - 1 + CAROUSEL_IMAGES.length) % CAROUSEL_IMAGES.length);
    }
  }, []);
  
  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      handleCarouselNav('next');
    }, 15000);
    
    return () => clearInterval(timer);
  }, [handleCarouselNav]);

  // Track page view for analytics (completely non-blocking)
  useEffect(() => {
    // Use requestIdleCallback for maximum non-blocking behavior
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => {
        trackPageView('home');
      }, { timeout: 2000 });
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(() => {
        trackPageView('home');
      }, 1500);
    }
  }, []); // Empty dependency array means this runs once on mount


  
  const handleSubscribeClick = () => {
    navigate('/pricing');
  };

  const handleViewPlansClick = () => {
    navigate('/pricing');
  };

  const handleSchoolsClick = () => {
    navigate('/schools');
  };

  const handlePricingClick = () => {
    navigate('/pricing');
  };

  return (
    <Box sx={{ 
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 30%, #2a2a2a 70%, #1a1a1a 100%)',
      minHeight: '100vh',
      color: 'white'
    }}>
      <NavBar />
      
      {/* Christmas Offer Banner */}
      {/* <ChristmasOfferBanner /> */}
      
      {/* Hero Banner Section */}
      <BannerContainer onClick={handlePricingClick} sx={{ cursor: 'pointer' }}>
        <BannerImage 
          src={HOME_BANNER_IMAGE}
          alt="YoungPresso - Kids News Magazine Banner"
          fetchpriority="high"
          loading="eager"
          onError={(e) => {
            e.target.style.backgroundColor = '#FF6B35';
            e.target.alt = 'YoungPresso Banner';
          }}
        />
      </BannerContainer>
      
      <Container maxWidth="xl">
        <Grid 
          container 
          spacing={{ xs: 4, md: 8 }} 
          sx={{ 
            minHeight: '80vh',
            alignItems: 'center',
            py: { xs: 4, md: 8 }
          }}
        >
          <Grid 
            item 
            xs={12} 
            md={6}
            sx={{
              order: { xs: 2, md: 1 },
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            <Typography 
            variant="h3" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: { xs: '2.2rem', sm: '2.8rem', md: '3.5rem' },
              mb: 4,
              px: { xs: 2, md: 0 },
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 800,
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              letterSpacing: '-0.02em',
              '& span': {
                background: 'linear-gradient(45deg, #06AED5 30%, #4FC3F7 70%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }
            }}
          >
            <span>Today's News</span> is Tomorrow's GK!
          </Typography>
            <Typography 
              variant="h6" 
              paragraph
              sx={{ 
                mb: 4,
                color: 'rgba(255,255,255,0.8)',
                fontSize: { xs: '1.1rem', md: '1.3rem' },
                lineHeight: 1.6,
                fontWeight: 400
              }}
            >
            NEWS made easy to understand and engaging for Kids. Especially designed by a Team of Professionals for comfortable reading on Tablet, Laptop and Mobiles. It’s a New-age Premium magazine with Innovative Designs to make sure Kids Read NEWS Happily.
            </Typography>

            <Grid container spacing={3} sx={{ mb: 4, justifyContent: { xs: 'center', md: 'flex-start' } }}>
              {[
                { icon: <NewspaperIcon />, text: 'News in simplified language' },
                { icon: <CalendarMonthIcon />, text: 'Weekly Online Magazine for GEN Alpha' },
                { icon: <AddReactionIcon />, text: 'Engaging fun activities' },
                { icon: <EmojiEventsIcon />, text: 'Current Affairs' },

              ].map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 1.5,
                    justifyContent: { xs: 'center', md: 'flex-start' },
                    p: 1.5,
                    borderRadius: '12px',
                    background: 'rgba(255,255,255,0.05)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,107,53,0.2)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'rgba(255,107,53,0.1)',
                      transform: 'translateY(-2px)'
                    }
                  }}>
                    <Box sx={{ 
                      color: '#FF6B35',
                      background: 'rgba(255,107,53,0.1)',
                      borderRadius: '8px',
                      p: 0.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>{item.icon}</Box>
                    <Typography sx={{ color: 'white', fontWeight: 500 }}>{item.text}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Box sx={{ 
              display: 'flex', 
              gap: 2, 
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', md: 'flex-start' }
            }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleSubscribeClick}
                sx={{
                  background: 'linear-gradient(45deg, #FF6B35 30%, #FF8A65 90%)',
                  borderRadius: '30px',
                  padding: { xs: '12px 28px', md: '16px 40px' },
                  fontSize: { xs: '1.1rem', md: '1.2rem' },
                  width: { xs: '100%', sm: 'auto' },
                  fontWeight: 600,
                  boxShadow: '0 8px 25px rgba(255,107,53,0.4)',
                  transition: 'all 0.4s ease',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #FF5722 30%, #FF6B35 90%)',
                    transform: 'translateY(-3px)',
                    boxShadow: '0 12px 35px rgba(255,107,53,0.5)',
                  }
                }}
              >
                Subscribe Now
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={handleViewPlansClick}
                sx={{
                  borderColor: '#06AED5',
                  color: '#06AED5',
                  borderRadius: '30px',
                  padding: { xs: '12px 28px', md: '16px 40px' },
                  fontSize: { xs: '1.1rem', md: '1.2rem' },
                  width: { xs: '100%', sm: 'auto' },
                  fontWeight: 600,
                  borderWidth: '2px',
                  transition: 'all 0.4s ease',
                  '&:hover': {
                    borderColor: '#0590B0',
                    backgroundColor: 'rgba(6,174,213,0.1)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(6,174,213,0.3)',
                  }
                }}
              >
                View Plans
              </Button>
            </Box>
          </Grid>
          <Grid 
            item 
            xs={12} 
            md={6}
            sx={{
              order: { xs: 1, md: 2 },
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                mb: { xs: 4, md: 0 }
              }}
            >
              {/* Magazine Covers Grid */}
              <Typography 
                variant="h6" 
                sx={{ 
                  textAlign: 'center',
                  color: '#FF6B35',
                  fontWeight: 600,
                  mb: 1
                }}
              >
               
              </Typography>
              
              <MagazineCoverGrid />
            </Box>
          </Grid>
        </Grid>
      </Container>

   {/* YouTube Video Player */}
          <Box sx={{ 
            width: '100%', 
            display: 'flex', 
            justifyContent: 'center', 
            my: { xs: 4, md: 8 },
            position: 'relative',
            paddingTop: '56.25%' /* 16:9 Aspect Ratio */
          }}>
            <iframe
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '16px', 
                boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
              }}
              src="https://www.youtube.com/embed/aYSOXjplpd4?autoplay=1&mute=1&modestbranding=1&rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </Box>

      <Box sx={{ py: 8, background: 'linear-gradient(135deg, rgba(6,174,213,0.05) 0%, rgba(255,107,53,0.05) 100%)' }}>
        <Container maxWidth="xl">
        <Typography 
            variant="h3" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: { xs: '2.2rem', sm: '2.6rem', md: '3rem' },
              mb: 4,
              px: { xs: 2, md: 0 },
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 800,
              '& span': {
                background: 'linear-gradient(45deg, #06AED5 30%, #4FC3F7 70%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }
            }}
          >

            
            <span>What is </span>in the Magazine?
          </Typography>

          <Typography variant="h6" align="center" sx={{ color: 'rgba(255,255,255,0.8)', mb: 6, fontSize: '1.2rem' }}>
            Explore the exciting content our magazine offers for young minds
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {[
              { 
                title: 'Current Affairs', 
                subtitle: 'Kid Friendly Language',
                icon: CURENT_AFFAIRS_IMAGE
              },
              { 
                title: 'Tech Updates', 
                subtitle: 'Keep Kids aligned with latest Tech',
                icon: LATEST_TECH_IMAGE 
              },
              { 
                title: 'Knowledge Bites', 
                subtitle: 'Word of the Week, Did You Know, Riddles etc.',
                icon: KNOWLEDGE_IMAGE 
              },
              { 
                title:  'Astronomy & Science', 
                subtitle: 'Space, Astronomy, Dinosaurs, Mummies, Cars and other Fascinating Topics',
                icon: CREATIVE_IMAGE 
              }
            ].map((item, index) => (
              <Grid 
                item 
                xs={12} 
                sm={6} 
                md={3} 
                key={index} 
onClick={handleSubscribeClick}
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  cursor: 'pointer'
                }}
              >
                <FeatureCard elevation={0}>
                  <Box sx={{ 
                    width: '100%',
                    paddingTop: '100%', // Creates a square aspect ratio
                    position: 'relative',
                    mb: 3,
                    borderRadius: '16px',
                    overflow: 'hidden',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(6,174,213,0.2)',
                    transition: 'all 0.4s ease',
                    '&:hover': {
                      transform: 'scale(1.05) translateY(-5px)',
                      boxShadow: '0 15px 35px rgba(6,174,213,0.3)',
                      border: '1px solid rgba(6,174,213,0.4)',
                    }
                  }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <FeatureImage 
                        src={item.icon} 
                        alt={item.title}
                        style={{ 
                          width: isMobile ? '100%' : '80%', 
                          height: isMobile ? '100%' : '80%', 
                          objectFit: 'contain',
                          borderRadius: isMobile ? '0' : '8px',
                          // Add different animation delay for each image
                          animationDelay: `${index * 0.2}s`
                        }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ width: '100%', px: 2 }}>
                    <Typography 
                      variant="h6" 
                      gutterBottom
                      sx={{ 
                        fontWeight: 'bold',
                        color: 'white',
                        fontSize: { xs: '1.25rem', md: '1.4rem' },
                        mb: 1,
                        minHeight: { md: '3.2rem' }
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography 
                      variant="subtitle1"
      onClick={handleSubscribeClick}
                      sx={{ 
                        color: '#06AED5',
                        fontSize: { xs: '0.95rem', md: '1rem' },
                        mb: 2,
                        fontWeight: 500,
                        minHeight: { md: '3rem' },
                        cursor: 'pointer'
                      }}
                    >
                      {item.subtitle}
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: 'rgba(255,255,255,0.7)',
                        fontSize: { xs: '0.9rem', md: '0.95rem' },
                        lineHeight: 1.6
                      }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
          
          {/* News for Everyone Image */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 6,
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(255, 255, 255, 0.02)',
              backdropFilter: 'blur(5px)',
              borderRadius: '20px',
              zIndex: -1
            }
          }}>
            <img 
              src="https://dp9h3awfnhccl.cloudfront.net/public_folder/news-for-everyone" 
              alt="News for Everyone" 
              onClick={() => navigate('/pricing')}
              style={{ 
                width: '100%', 
                maxWidth: '90%',
                height: 'auto', 
                borderRadius: '12px', 
                boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }} 
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.02)';
                e.target.style.boxShadow = '0 12px 40px rgba(255, 107, 53, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.4)';
              }}
            />
          </Box>
          
        </Container>
      </Box>

      <Box sx={{ py: 8, background: 'linear-gradient(135deg, rgba(255,107,53,0.05) 0%, rgba(6,174,213,0.05) 100%)' }}>
        <Container maxWidth="xl">
        <Typography 
            variant="h3" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: { xs: '2.2rem', sm: '2.6rem', md: '3rem' },
              mb: 4,
              px: { xs: 2, md: 0 },
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 800,
              '& span': {
                background: 'linear-gradient(45deg, #06AED5 30%, #4FC3F7 70%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }
            }}
          >
            <span>Why  </span>kids Love YoungPresso!
          </Typography>

          <Typography variant="h6" align="center" sx={{ color: 'rgba(255,255,255,0.8)', mb: 6, fontSize: '1.2rem' }}>
            Discover what makes us a Perfect choice for Kids of Age 5+
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {[
              { 
                title: 'Digital Friendly', 
                subtitle: 'For our Tech Savvy Kids',
                desc: 'Kids today are more tech-savvy than us. Instead of reading traditional newspapers, they prefer using digital devices. YoungPresso is crafted for easy reading on any digital platform—be it a Mobile, Tablet, or Laptop. Its the only screentime that you will actually feel good about!',
                icon: DIGITAL_FRIENDLY_ICON 
              },
              { 
                title: 'Easy to Understand', 
                subtitle: 'Vocabulary rich sentences',
                desc: 'Kids find our News sections easy to understand and super-engaging. Statistics show they are among our most engaging pages. ',
                icon: MAKE_IT_EASY_ICON 
              },
              { 
                title: 'Rewards, Prizes and Certificates', 
                subtitle: 'Encouragement and recognition',
                desc: 'We offer attractive rewards and prizes for active participation in our contests and activities.',
                icon: REWARDS_ICON 
              },
              { 
                title: 'Wall of Fame', 
                subtitle: 'A Platform to showcase your talent',
                desc: 'This is a special section where our young subscribers get a chance to be featured in our magazine. They can use this space to display their drawings, share unique talents, or promote their new storybook or YouTube channel.',
                icon: WALL_OF_FAME_ICON 
              }
            ].map((item, index) => (
              <Grid 
                item 
                xs={12} 
                sm={6} 
                md={3} 
                key={index} 
onClick={handleSubscribeClick}
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  cursor: 'pointer'
                }}
              >
                <FeatureCard elevation={0}>
                  <Box sx={{ 
                    width: '100%',
                    paddingTop: '100%', // Creates a square aspect ratio
                    position: 'relative',
                    mb: 3,
                    borderRadius: '16px',
                    overflow: 'hidden',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,107,53,0.2)',
                    transition: 'all 0.4s ease',
                    '&:hover': {
                      transform: 'scale(1.05) translateY(-5px)',
                      boxShadow: '0 15px 35px rgba(255,107,53,0.3)',
                      border: '1px solid rgba(255,107,53,0.4)',
                    }
                  }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <FeatureImage 
                        src={item.icon} 
                        alt={item.title}
                        style={{ 
                          width: isMobile ? '100%' : '80%', 
                          height: isMobile ? '100%' : '80%', 
                          objectFit: 'contain',
                          borderRadius: isMobile ? '0' : '8px' 
                        }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ width: '100%', px: 2 }}>
                    <Typography 
                      variant="h6" 
                      gutterBottom
                      sx={{ 
                        fontWeight: 'bold',
                        color: 'white',
                        fontSize: { xs: '1.25rem', md: '1.4rem' },
                        mb: 1,
                        minHeight: { md: '3.2rem' }
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography 
                      variant="subtitle1"
                      sx={{ 
                        color: '#FF6B35',
                        fontSize: { xs: '0.95rem', md: '1rem' },
                        mb: 2,
                        fontWeight: 500,
                        minHeight: { md: '3rem' }
                      }}
                    >
                      {item.subtitle}
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: 'rgba(255,255,255,0.7)',
                        fontSize: { xs: '0.9rem', md: '0.95rem' },
                        lineHeight: 1.6
                      }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>


      
      <Box sx={{ 
        py: 8, 
        position: 'relative',
        background: 'linear-gradient(135deg, rgba(6,174,213,0.08) 0%, rgba(255,107,53,0.08) 100%)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.1)'
      }}>
        <Container maxWidth="xl" align="center">
          <Typography 
            variant="h3" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: { xs: '2.2rem', sm: '2.6rem', md: '3rem' },
              mb: 4,
              px: { xs: 2, md: 0 },
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 800,
              '& span': {
                background: 'linear-gradient(45deg, #06AED5 30%, #4FC3F7 70%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }
            }}
          >
            <span>Trusted by Parents</span>  Loved by Kids!
          </Typography>
        </Container>
      </Box>

      {/* Testimonials Section */}
      <Testimonials />
      
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        mt: 4
      }}>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={handleSubscribeClick}
          sx={{ color: 'white' }}
        >
          Subscribe Now
        </ActionButton>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container maxWidth="xl">
          {/* Importance of News Image */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 6,
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(255, 255, 255, 0.02)',
              backdropFilter: 'blur(5px)',
              borderRadius: '20px',
              zIndex: -1
            }
          }}>
            <img 
              src="https://dp9h3awfnhccl.cloudfront.net/public_folder/importance-of-news-home" 
              alt="Importance of News" 
              style={{ 
                width: '100%', 
                maxWidth: '600px',
                height: 'auto', 
                borderRadius: '12px', 
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease'
              }} 
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.02)';
                e.target.style.boxShadow = '0 12px 40px rgba(255, 107, 53, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.4)';
              }}
            />
          </Box>
          
        </Container>
        
      </Box>




      {/* Call to Action Section */}
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Container maxWidth="xl">
        <Typography 
            variant="h3" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
              mb: 3,
              px: { xs: 2, md: 0 },
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              color: '#FF6B35',
              fontWeight: 700,
              textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
              '& span': {
                color: '#06AED5'
              }
            }}
          >
            <span>Start </span> Your Child's News Journey Today!
          </Typography>
          <Typography variant="h6" color="white" paragraph>
            Your small step today will be a giant leap for your child's future.
          </Typography>
          <ActionButton
            variant="contained"
            color="primary"
            onClick={handleSubscribeClick}
            sx={{ mt: 4, color: 'white' }}
          >
            Join Us!
          </ActionButton>
        </Container>
      </Box>


      <Footer />
    </Box>
  );
};

export default Home;
